<template>
  <Article>
    <Heading as="h1">
      <!--  -->
      Entertainment + Film Financing
    </Heading>

  </Article>
</template>

<script setup>
defineOptions({ name: "ViewEntertainment" });
import Article from "../components/Article.vue";
import Heading from "../components/Heading.vue";
</script>
